import { render, staticRenderFns } from "./forks_button.vue?vue&type=template&id=300bfdb6"
import script from "./forks_button.vue?vue&type=script&lang=js"
export * from "./forks_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports